<template>
  <div class="page-operative setup-company-page">
    <div class="h-100 d-flex flex-column">
        <div class="h-100 d-flex justify-content-center" :class="[ action === 'settings' ? 'align-items-start' : 'align-items-center' ]">
          <transition name="slide">
            <StartSetupSlide v-if="!started || action === 'setup'" @input="setStartSetupAnswer" />
            <SettingsSlide v-else-if="!settingsSaved || action === 'settings'" @submitForm="saveSettings" />
            <HasBalanceSlide v-else-if="null === hasBalance || action === 'ask-balance'" @has-balance="setHasBalance" @goBack="resetToSettings" />
            <SelectMonthSlide v-else-if="!selectedDate" :hasBalance="hasBalance" @selectMonth="selectMonth" @goBack="resetHasBalance" />
            <AddStatement v-else-if="hasBalance" :year="selectedDateYear" :month="selectedDateMonth" @save="finalizeSetup" @goBack="resetSelectedDate" />
          </transition>
        </div>
    </div>
  </div>
</template>

<script>

import operativePageMixin from '../../../../mixins/operativePage';

export default {
  components: {
    StartSetupSlide: () => import('./StartSetupSlide'),
    SettingsSlide: () => import('./SettingsSlide'),
    HasBalanceSlide: () => import('./HasBalanceSlide'),
    SelectMonthSlide: () => import('./SelectMonthSlide'),
    AddStatement: () => import('./AddStatement'),
  },
  mixins: [operativePageMixin],
  data () {
    return {
      action: null,
      started: false,
      settingsSaved: false,
      hasBalance: null,
      selectedDate: null,
    };
  },
  computed: {
    me () {
      return this.$oauth2?.me;
    },
    selectedDateYear () {
      return this.selectedDate?.year;
    },
    selectedDateMonth () {
      return this.selectedDate?.month;
    },
  },
  methods: {
    setStartSetupAnswer (answer) {
      if (!answer) {
        this.$router.replace({ name: 'root' });

        return;
      }

      this.navigateToAction('settings');
      this.started = true;
    },
    saveSettings (settings) {
      this.$api.saveSettings(this.$route.params.id, settings).then(res => {
        this.settingsSaved = true;
        this.navigateToAction('ask-balance');
      }, err => {
        this.settingsSaved = true;
        this.navigateToAction('ask-balance');
        this.$log.error(err);
      });
    },
    setHasBalance (hasBalance) {
      this.hasBalance = hasBalance;
      this.navigateToAction('select-month');
    },
    selectMonth (date) {
      this.selectedDate = date;

      if (this.hasBalance === false) {
        this.finalizeSetup(date);

        return;
      }

      this.navigateToAction('set-balance');
    },
    goToStart () {
      this.$log.debug('asdds');
    },
    navigateToAction (action, replace = false) {
      if (this.$route.query?.action === action) {
        return;
      }

      return this.$router[
        replace ? 'replace' : 'push'
      ]({ name: 'operative-company', query: { action } });
    },
    finalizeSetup (data) {
      this.$emit('finalizeSetup', data);
    },
    resetToSettings () {
      this.settingsSaved = false;
      this.navigateToAction('settings');
    },
    resetHasBalance () {
      this.hasBalance = null;
      this.navigateToAction('ask-balance');
    },
    resetSelectedDate () {
      this.selectedDate = null;
      this.navigateToAction('select-month');
    },
  },
  watch: {
    $route: {
      handler (to) {
        this.action = to?.query?.action || 'setup';
      },
      immediate: true,
      deep: true,
    },
  },
  mounted () {
    if (this.$route.name !== 'operative-company') {
      this.navigateToAction('setup', true);
    }
  },
};

</script>

<style lang="scss">

.setup-company-page {
  overflow: auto;
}

</style>
